import { render } from "./area.vue?vue&type=template&id=57f61eb3"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__